export const authTokenExcludedOperations = new Set<string>(["Localizations"]);
